import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.principal');

    core.constant(
        'REPORTS',
        Object.freeze({
            reports: {
                types: [
                    'ALL',
                    'PRINCIPAL_IMPORT_BUYERS',
                    'PRINCIPAL_IMPORT_SELLERS',
                    'PRINCIPAL_IMPORT_BUSREL',
                    'PRINCIPAL_EXPORT_INVITATIONS',
                    'PRINCIPAL_EXPORT_INVITATIONS_RPT',
                    'PRINCIPAL_VALIDATE_SENDING_NOTIFICATIONS',
                    'PRINCIPAL_EDITIQUE_INSCRIPTION_REMINDER',
                    'PRINCIPAL_EDITIQUE_INSCRIPTION_NO_EMAIL_REMINDER',
                    'PRINCIPAL_EDITIQUE_BUYER_INSCRIPTION_REMINDER',
                    'PRINCIPAL_IMPORT_BATCH_SELLERS_RELATIONS',
                    'PRINCIPAL_IMPORT_BATCH_BUYERS_RELATIONS',
                    'PRINCIPAL_IMPORT_INVBUY',
                    'PRINCIPAL_IMPORT_BUSREL_INVBUY',
                    'PRINCIPAL_IMPORT_BUYER_SUBENTITIES',
                    'PRINCIPAL_IMPORT_BUSREL_SUBENTITIES_INVBUY',
                    'BUYER_INVFLY_ERRORS_REPORT_EXPORT',
                    'SELLER_INVFLY_ERRORS_REPORT_EXPORT',
                    'LAD_AUTO_REPORT',
                    'SELLER_REGISTRATION_REPORT',
                    'BUYER_REGISTRATION_REPORT',
                    'REJECTED_INVOICES_REPORT',
                    'PRINCIPAL_IMPORT_USERS'
                ],
                pagination: {
                    defaultPageSize: 20,
                    defaultSort: [
                        {
                            direction: 'DESC',
                            property: 'date',
                        },
                    ],
                    defaultPage: 0,
                },
                columnFieldMap: [
                    {
                        field: 'date',
                        property: 'date',
                    },
                    {
                        field: 'type',
                        property: 'type',
                    },
                    {
                        field: 'name',
                        property: 'name',
                    },
                ],
            },
        })
    );
})();
